import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const CPiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='65'
        height='128'
        viewBox='0 0 65 128'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M64.6672 120.348C64.6672 124.766 61.0716 128.4 56.6877 127.85C42.6279 126.086 29.4634 119.698 19.3377 109.572C7.3155 97.5499 0.561523 81.2443 0.561523 64.2424C0.561524 47.2405 7.3155 30.935 19.3377 18.9128C29.4634 8.78706 42.6279 2.39853 56.6877 0.635036C61.0716 0.0851694 64.6672 3.71844 64.6672 8.13672V64.2424V120.348Z' />
      </svg>
    </div>
  );
});

CPiece.displayName = 'CPiece';

export default motion.create(CPiece);
